module.exports = "/_next/static/images/DeliveryCentrifuge-5667df5e914c30a370114a921170e349.webp";